import { render } from "./FreshwayHeader.vue?vue&type=template&id=5b70097e&scoped=true"
import script from "./FreshwayHeader.vue?vue&type=script&lang=js"
export * from "./FreshwayHeader.vue?vue&type=script&lang=js"

import "./FreshwayHeader.vue?vue&type=style&index=0&id=5b70097e&scoped=true&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b70097e"]])

export default __exports__